import FormStore from 'lib/stores/formStore';

const useFormField = name => {
  const profileElements = FormStore.useState(state => state.profile_elements);
  const formState = FormStore.useState(state => state);
  const isProfileElement = name.includes('profile_elements');
  const [section, element, elementChild] = name.split('.').slice(1);

  const findValue = (obj, path) => {
    if (!path) return obj;

    const properties = path.split('.');

    return findValue(obj[properties.shift()], properties.join('.'));
  };

  const profileElementExists = () => {
    if (!Object.prototype.hasOwnProperty.call(profileElements, section)) return false;
    if (!Object.prototype.hasOwnProperty.call(profileElements[section], element)) return false;

    if (!elementChild) return true;

    try {
      const parsed = JSON.parse(`${profileElements[section][element]}`);

      FormStore.update(state => { state.profile_elements[section][element] = parsed; });

      return Object.prototype.hasOwnProperty.call(parsed, elementChild);
    } catch (e) {
      return Object.prototype.hasOwnProperty.call(profileElements[section][element], elementChild);
    }
  };

  const getDefaultElementValue = () => {
    if (element.includes('|Array')) return [];

    return '';
  };

  const getProfileElement = () => {
    if (!profileElementExists()) return getDefaultElementValue();
    if (element.includes('|Object')) return profileElements[section][element][elementChild] || '';

    const foundElement = elementChild ? profileElements[section][element][elementChild]
      : profileElements[section][element];

    if (typeof foundElement === 'boolean') return foundElement.toString();

    return foundElement;
  };

  return [isProfileElement ? getProfileElement() : (findValue(formState, name) || '')];
};

export default useFormField;
